export default "__VITE_ASSET__ef25ba13__"